export default __webpack_public_path__ + "c4d1559e60c7de41fd7098a94d304476.png";